import { useState } from 'react'
import * as Sentry from '@sentry/react'

import { getAuthenticatedUser, login, setLocalAuthKey } from '.'
import {
  ROUTE_LOGIN,
  ROUTE_LOGOUT,
  ROUTE_TODAY
} from 'components/common/helpers/Paths'
import { Col, Container, Row, Spinner } from 'react-bootstrap'
import { authenticateUser } from 'components/common/api/Users'
import {
  postMobileKeychain,
  postMobileToken,
  privateAuth
} from 'components/common/helpers/Mobile'

let _isWaiting = false

window._privateLogin = ({ email, password }) => {
  // Do we have query params?
  const searchParams = new URLSearchParams(window.location.search)

  // Did we have a return path?
  const redirectPath = searchParams.get('returnPath') || ROUTE_TODAY

  // If we don't have an email or password, we can't log in,
  // so just redirect to the login page
  // If we're already waiting for a login, don't do anything
  if (!_isWaiting && (!email || !password)) {
    // Use hard redirect to avoid any weirdness with the router
    window.location.href = ROUTE_LOGOUT
    return
  }

  // Try to log in
  async function tryLogin() {
    // Return early if we're already waiting for a login
    if (_isWaiting) return

    // Use a private variable to track if we're waiting for a login
    _isWaiting = true

    try {
      // Wait for authentication
      await authenticateUser({
        email,
        password
      })
        .then(async result => {
          // Success?
          if (!result.token)
            throw new Error(
              `No token returned. Auto login failed with result: ${JSON.stringify(
                result
              )}`
            )

          login(result)
          setLocalAuthKey(result.token) // Sets local storage to dismiss the in-app auth screen
          postMobileKeychain(email, password) // Save the email and password to the keychain

          // Get the user data from the auth token
          const authenticatedUser = getAuthenticatedUser(result.token)
          const remble_id = authenticatedUser.aurora_id

          postMobileKeychain({ email, password, remble_id })
          login(result)
          postMobileToken(result.token)
          setLocalAuthKey(result.token) // Sets local storage to dismiss the in-app auth screen

          // Use hard redirect to avoid any weirdness with the router
          window.location.href = redirectPath
        })
        .catch(error => {
          throw new Error(error)
        })
    } catch (e) {
      Sentry.captureException(e)
      console.error(e)

      // Something went wrong, so redirect to the logout page to clear the auth token and try again
      window.location.href = ROUTE_LOGOUT
    }
  }
  tryLogin()
}

/**
 * Private login component, used for mobile app login and to bypass the login GUI
 */
export default function PrivateLogin() {
  const [hasTimedOut, setHasTimedOut] = useState(false)

  // Show the spinner for 5 seconds, then redirect to the login page if something went wrong
  const logoutTimeout = setTimeout(() => {
    setHasTimedOut(true)
    clearTimeout(logoutTimeout)
    window._privateLogin({ email: null, password: null }) // Run the login function manually
  }, 5000)

  // Trigger private mobile login
  privateAuth()

  return (
    <Container>
      <Row>
        <Col xs={12} className='text-center'>
          <Spinner
            animation='border'
            role='status'
            variant='primary'
            size='lg'
            className='my-4'
          >
            <span className='visually-hidden'>Loading...</span>
          </Spinner>
          <h4 className='title muted'>Getting things ready...</h4>
          {hasTimedOut && (
            <h6 className='muted title'>
              If you're not automatically redirected, please click{' '}
              <a href={ROUTE_LOGIN}>here</a>.
            </h6>
          )}
        </Col>
      </Row>
    </Container>
  )
}
